import { useTranslation } from 'react-i18next';
import { styled } from "@mui/material";

const StyledContainer = styled('div')({
    paddingLeft: '2rem',
    paddingRight: '2rem',
    maxWidth: '800px',
    margin: '0 auto'
});

export const PrivacyPolicyPage = () => {
    const { i18n } = useTranslation();

    const version = i18n.language === 'en' ? enVersion() : plVersion();

    return (
        <StyledContainer>
          {version}
        </StyledContainer>
      );
};

const plVersion = () => {
    return (
        <div>
          <h1>Polityka prywatności Interaktywnego Systemu Szkoleniowego VR</h1>
          <h3>
            Polityka prywatności opisuje zasady przetwarzania przez nas informacji na Twój temat,
            w tym danych osobowych oraz ciasteczek, czyli tzw. cookies.
          </h3>
    
          <h2>1. Informacje ogólne</h2>
          <ul>
            <li>
              Niniejsza polityka dotyczy Serwisu www, funkcjonującego pod adresem url:{' '}
              <strong>app.vrtrainingsystem.com</strong>
            </li>
            <li>
              Operatorem serwisu oraz Administratorem danych osobowych jest:
              CinematicVR sp. z o. o. al. Piłsudskiego 17/4, 35-074 Rzeszów
            </li>
            <li>Adres kontaktowy poczty elektronicznej operatora: kontakt@cinematicvr.pl</li>
            <li>
              Operator jest Administratorem Twoich danych osobowych w odniesieniu do danych podanych dobrowolnie w Serwisie.
            </li>
            <li>Serwis wykorzystuje dane osobowe w następujących celach:</li>
            <ol>
              <li>Realizacja zamówionych usług</li>
            </ol>
            <li>
              Serwis realizuje funkcje pozyskiwania informacji o użytkownikach i ich zachowaniu w następujący sposób:
            </li>
            <ol>
              <li>
                Poprzez dobrowolnie wprowadzone w formularzach dane, które zostają wprowadzone do systemów Operatora.
              </li>
              <li>Poprzez zapisywanie w urządzeniach końcowych plików cookie (tzw. „ciasteczka”).</li>
            </ol>
          </ul>
    
          <h2>2. Wybrane metody ochrony danych stosowane przez Operatora</h2>
          <ul>
            <li>
              Miejsca logowania i wprowadzania danych osobowych są chronione w warstwie transmisji (certyfikat SSL).
              Dzięki temu dane osobowe i dane logowania, wprowadzone na stronie, zostają zaszyfrowane w komputerze użytkownika
              i mogą być odczytane jedynie na docelowym serwerze.
            </li>
            <li>
              Dane osobowe przechowywane w bazie danych są zaszyfrowane w taki sposób, że jedynie posiadający Operator klucz
              może je odczytać. Dzięki temu dane są chronione na wypadek wykradzenia bazy danych z serwera.
            </li>
            <li>
              Hasła użytkowników są przechowywane w postaci hashowanej. Funkcja hashująca działa jednokierunkowo - nie jest możliwe
              odwrócenie jej działania, co stanowi obecnie współczesny standard w zakresie przechowywania haseł użytkowników.
            </li>
            <li>Operator okresowo zmienia swoje hasła administracyjne.</li>
            <li>W celu ochrony danych Operator regularnie wykonuje kopie bezpieczeństwa.</li>
            <li>
              Istotnym elementem ochrony danych jest regularna aktualizacja wszelkiego oprogramowania, wykorzystywanego przez Operatora
              do przetwarzania danych osobowych, co w szczególności oznacza regularne aktualizacje komponentów programistycznych.
            </li>
          </ul>
    
          <h2>3. Hosting</h2>
          <ul>
            <li>Serwis jest hostowany (technicznie utrzymywany) na serwerach operatora: OVH</li>
            <li>
              Firma hostingowa w celu zapewnienia niezawodności technicznej prowadzi logi na poziomie serwera. Zapisowi mogą podlegać:
            </li>
            <ol>
              <li>zasoby określone identyfikatorem URL (adresy żądanych zasobów – stron, plików),</li>
              <li>czas nadejścia zapytania,</li>
              <li>czas wysłania odpowiedzi,</li>
              <li>nazwę stacji klienta – identyfikacja realizowana przez protokół HTTP,</li>
              <li>informacje o błędach jakie nastąpiły przy realizacji transakcji HTTP,</li>
              <li>adres URL strony poprzednio odwiedzanej przez użytkownika (referer link),</li>
              <li>informacje o przeglądarce użytkownika,</li>
              <li>informacje o adresie IP,</li>
              <li>informacje diagnostyczne związane z procesem samodzielnego zamawiania usług poprzez rejestratory na stronie,</li>
              <li>informacje związane z obsługą poczty elektronicznej kierowanej do Operatora oraz wysyłanej przez Operatora.</li>
            </ol>
          </ul>
    
          <h2>4. Twoje prawa i dodatkowe informacje o sposobie wykorzystania danych</h2>
          <ul>
            <li>
              W niektórych sytuacjach Administrator ma prawo przekazywać Twoje dane osobowe innym odbiorcom, jeśli będzie to niezbędne
              do wykonania zawartej z Tobą umowy lub do zrealizowania obowiązków ciążących na Administratorze.
              Dotyczy to takich grup odbiorców:
            </li>
            <ol>
              <li>firma hostingowa na zasadzie powierzenia</li>
            </ol>
            <li>
              Twoje dane osobowe przetwarzane przez Administratora nie dłużej, niż jest to konieczne do wykonania związanych z nimi
              czynności określonych osobnymi przepisami (np. o prowadzeniu rachunkowości).
            </li>
            <li>Przysługuje Ci prawo żądania od Administratora:</li>
            <ol>
              <li>dostępu do danych osobowych Ciebie dotyczących,</li>
              <li>ich sprostowania,</li>
              <li>usunięcia,</li>
              <li>ograniczenia przetwarzania,</li>
              <li>oraz przenoszenia danych.</li>
            </ol>
            <li>
              Przysługuje Ci prawo do złożenia sprzeciwu wobec przetwarzania wskazanego w pkt 3.2 w celu wykonania prawnie uzasadnionych interesów
              realizowanych przez Administratora, w tym profilowania, przy czym prawo sprzeciwu nie będzie mogło być wykonane w przypadku istnienia
              ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Ciebie interesów, praw i wolności,
              w szczególności ustalenia, dochodzenia lub obrony roszczeń.
            </li>
            <li>
              Na działania Administratora przysługuje skarga do Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa.
            </li>
            <li>Podanie danych osobowych jest dobrowolne, lecz niezbędne do obsługi Serwisu.</li>
            <li>
              W stosunku do Ciebie mogą być podejmowane czynności polegające na zautomatyzowanym podejmowaniu decyzji,
              w tym profilowaniu w celu świadczenia usług w ramach zawartej umowy oraz w celu prowadzenia przez Administratora marketingu bezpośredniego.
            </li>
            <li>
              Dane osobowe nie są przekazywane do krajów trzecich w rozumieniu przepisów o ochronie danych osobowych.
              Oznacza to, że nie przesyłamy ich poza teren Unii Europejskiej.
            </li>
          </ul>
    
          <h2>5. Informacje w formularzach</h2>
          <ul>
            <li>Serwis zbiera informacje podane dobrowolnie przez użytkownika, w tym dane osobowe, o ile zostaną one podane.</li>
            <li>Serwis może zapisać informacje o parametrach połączenia (oznaczenie czasu, adres IP).</li>
            <li>
              Serwis, w niektórych wypadkach, może zapisać informację ułatwiającą powiązanie danych w formularzu
              z adresem e-mail użytkownika wypełniającego formularz. W takim wypadku adres e-mail użytkownika pojawia się wewnątrz adresu URL.
            </li>
            <li>
              Dane podane w formularzu są przetwarzane w celu wynikającym z funkcji konkretnego formularza,
              np. w celu obsługi zgłoszenia serwisowego lub kontaktu handlowego, rejestracji usług itp.
              Każdorazowo kontekst i opis formularza w czytelny sposób informuje, do czego on służy.
            </li>
          </ul>
    
          <h2>6. Logi Administratora</h2>
          <ul>
            <li>
              Informacje o zachowaniu użytkowników w serwisie mogą podlegać logowaniu. Dane te są wykorzystywane w celu administrowania serwisem.
            </li>
          </ul>
    
          <h2>7. Istotne techniki marketingowe</h2>
          <ul>
            <li>
              Operator stosuje analizę statystyczną ruchu na stronie poprzez Google Analytics (Google Inc. z siedzibą w USA).
              Operator nie przekazuje do operatora tej usługi danych osobowych, a jedynie zanonimizowane informacje.
              Usługa bazuje na wykorzystaniu ciasteczek w urządzeniu końcowym użytkownika.
              W zakresie informacji o preferencjach użytkownika gromadzonych przez sieć reklamową Google użytkownik
              może przeglądać i edytować informacje wynikające z plików cookies przy pomocy narzędzia:{' '}
              <a href="https://www.google.com/ads/preferences/">https://www.google.com/ads/preferences/</a>
            </li>
          </ul>
    
          <h2>8. Informacja o plikach cookies</h2>
          <ul>
            <li>Serwis korzysta z plików cookies.</li>
            <li>
              Pliki cookies („ciasteczka”) stanowią dane informatyczne, w szczególności pliki tekstowe,
              które przechowywane są w urządzeniu końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze stron internetowych Serwisu.
              Cookies zazwyczaj zawierają nazwę strony internetowej, z której pochodzą, czas przechowywania ich na urządzeniu końcowym oraz unikalny numer.
            </li>
            <li>
              Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu pliki cookies oraz uzyskującym do nich dostęp jest operator Serwisu.
            </li>
            <li>Pliki cookies wykorzystywane są w następujących celach:</li>
            <ol>
              <li>utrzymanie sesji użytkownika Serwisu (po zalogowaniu), dzięki której użytkownik nie musi na każdej podstronie ponownie wpisywać loginu i hasła;</li>
              <li>realizacja celów określonych powyżej w części "Istotne techniki marketingowe";</li>
            </ol>
            <li>
              W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: „sesyjne” (session cookies) oraz „stałe” (persistent cookies).
              Cookies „sesyjne” są plikami tymczasowymi, które przechowywane są w urządzeniu końcowym Użytkownika do czasu wylogowania,
              opuszczenia strony internetowej lub wyłączenia przeglądarki internetowej.
              „Stałe” pliki cookies przechowywane są w urządzeniu końcowym Użytkownika przez czas określony w parametrach plików cookies
              lub do czasu ich usunięcia przez Użytkownika.
            </li>
            <li>
              Oprogramowanie do przeglądania stron internetowych (przeglądarka internetowa) zazwyczaj domyślnie dopuszcza przechowywanie plików cookies
              w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą dokonać zmiany ustawień w tym zakresie.
              Przeglądarka internetowa umożliwia usunięcie plików cookies. Możliwe jest także automatyczne blokowanie plików cookies.
              Szczegółowe informacje na ten temat zawiera pomoc lub dokumentacja przeglądarki internetowej.
            </li>
            <li>Ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności dostępne na stronach internetowych Serwisu.</li>
            <li>
              Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu wykorzystywane mogą być również przez współpracujące
              z operatorem Serwisu podmioty, w szczególności dotyczy to firm: Google (Google Inc. z siedzibą w USA),
              Facebook (Facebook Inc. z siedzibą w USA), Twitter (Twitter Inc. z siedzibą w USA).
            </li>
          </ul>
    
          <h2>9. Zarządzanie plikami cookies – jak w praktyce wyrażać i cofać zgodę?</h2>
          <ul>
            <li>
              Jeśli użytkownik nie chce otrzymywać plików cookies, może zmienić ustawienia przeglądarki.
              Zastrzegamy, że wyłączenie obsługi plików cookies niezbędnych dla procesów uwierzytelniania, bezpieczeństwa,
              utrzymania preferencji użytkownika może utrudnić, a w skrajnych przypadkach może uniemożliwić korzystanie ze stron www.
            </li>
            <li>
              W celu zarządzania ustawieniami cookies wybierz z listy poniżej przeglądarkę internetową, której używasz,
              i postępuj zgodnie z instrukcjami:
              <ul>
                <li>
                  <a href="https://support.microsoft.com/pl-pl/help/10607/microsoft-edge-view-delete-browser-history">Edge</a>
                </li>
                <li>
                  <a href="https://support.microsoft.com/pl-pl/help/278835/how-to-delete-cookie-files-in-internet-explorer">
                    Internet Explorer
                  </a>
                </li>
                <li>
                  <a href="http://support.google.com/chrome/bin/answer.py?hl=pl&answer=95647">Chrome</a>
                </li>
                <li>
                  <a href="http://support.apple.com/kb/PH5042">Safari</a>
                </li>
                <li>
                  <a href="http://support.mozilla.org/pl/kb/W%C5%82%C4%85czanie%20i%20wy%C5%82%C4%85czanie%20obs%C5%82ugi%20ciasteczek">
                    Firefox
                  </a>
                </li>
                <li>
                  <a href="http://help.opera.com/Windows/12.10/pl/cookies.html">Opera</a>
                </li>
              </ul>
            </li>
            <li>Urządzenia mobilne:</li>
            <ul>
              <li>
                <a href="http://support.google.com/chrome/bin/answer.py?hl=pl&answer=95647">Android</a>
              </li>
              <li>
                <a href="http://support.apple.com/kb/HT1677?viewlocale=pl_PL">Safari (iOS)</a>
              </li>
              <li>
                <a href="http://www.windowsphone.com/pl-pl/how-to/wp7/web/changing-privacy-and-other-browser-settings">
                  Windows Phone
                </a>
              </li>
            </ul>
          </ul>
        </div>
      );
}

const enVersion = () => {
    return (
        <div>
          <h1>Privacy Policy of the Interactive VR Training System</h1>
          <h3>
            This Privacy Policy describes the principles of how we process information about you, including personal data and cookies.
          </h3>
    
          <h2>1. General Information</h2>
          <ul>
            <li>
              This policy applies to the website operating at: <strong>app.vrtrainingsystem.com</strong>
            </li>
            <li>
              The operator of the website and the personal data administrator is: CinematicVR sp. z o. o., al. Piłsudskiego 17/4, 35-074 Rzeszów, Poland.
            </li>
            <li>Contact email address of the operator: kontakt@cinematicvr.pl</li>
            <li>
              The Operator is the Administrator of your personal data regarding the data provided voluntarily on the website.
            </li>
            <li>The website uses personal data for the following purposes:</li>
            <ol>
              <li>Provision of ordered services</li>
            </ol>
            <li>
              The website gathers information about users and their behavior in the following ways:
            </li>
            <ol>
              <li>Through voluntarily entered data in forms that are entered into the Operator's systems.</li>
              <li>By storing cookies on end-user devices ("cookies").</li>
            </ol>
          </ul>
    
          <h2>2. Selected Data Protection Methods Used by the Operator</h2>
          <ul>
            <li>
              Login areas and personal data entry points are protected at the transmission layer (SSL certificate).
              This means that personal data and login details entered on the website are encrypted on the user's computer
              and can only be read on the target server.
            </li>
            <li>
              Personal data stored in the database are encrypted in such a way that only the Operator holding the key can read them.
              This protects the data in the event of the database being stolen from the server.
            </li>
            <li>
              User passwords are stored in hashed form. The hashing function works one-way — it cannot be reversed,
              which is the current standard for storing user passwords.
            </li>
            <li>The Operator periodically changes its administrative passwords.</li>
            <li>To protect data, the Operator regularly creates backup copies.</li>
            <li>
              An important element of data protection is regular updates of all software used by the Operator to process personal data,
              in particular, regular updates of programming components.
            </li>
          </ul>
    
          <h2>3. Hosting</h2>
          <ul>
            <li>The website is hosted (technically maintained) on the servers of: OVH</li>
            <li>
              To ensure technical reliability, the hosting company keeps logs at the server level. The logs may include:
            </li>
            <ol>
              <li>resources specified by a URL identifier (addresses of requested pages, files),</li>
              <li>time of request arrival,</li>
              <li>time of sending the response,</li>
              <li>client station name – identification carried out by the HTTP protocol,</li>
              <li>information about errors that occurred during HTTP transactions,</li>
              <li>URL address of the page previously visited by the user (referer link),</li>
              <li>information about the user's browser,</li>
              <li>IP address,</li>
              <li>diagnostic information related to the self-ordering of services via recorders on the website,</li>
              <li>information related to email correspondence sent to and from the Operator.</li>
            </ol>
          </ul>
    
          <h2>4. Your Rights and Additional Information on How Data is Used</h2>
          <ul>
            <li>
              In some situations, the Administrator has the right to transfer your personal data to other recipients
              if it is necessary to perform a contract with you or to fulfill obligations incumbent on the Administrator.
              This applies to the following groups of recipients:
            </li>
            <ol>
              <li>hosting company under entrustment agreement</li>
            </ol>
            <li>
              Your personal data processed by the Administrator will not be kept longer than necessary to carry out activities
              related to them as specified by separate regulations (e.g., accounting regulations).
            </li>
            <li>You have the right to request from the Administrator:</li>
            <ol>
              <li>access to your personal data,</li>
              <li>rectification,</li>
              <li>deletion,</li>
              <li>restriction of processing,</li>
              <li>and data portability.</li>
            </ol>
            <li>
              You have the right to object to the processing referred to in point 3.2 concerning the processing of personal data
              to perform legally justified interests pursued by the Administrator, including profiling,
              but the right to object will not apply if there are valid legally justified grounds for processing,
              overriding your interests, rights, and freedoms, in particular establishing, pursuing, or defending claims.
            </li>
            <li>
              You have the right to lodge a complaint about the Administrator's actions to the President of the Personal Data Protection Office,
              ul. Stawki 2, 00-193 Warsaw, Poland.
            </li>
            <li>Providing personal data is voluntary but necessary to use the website.</li>
            <li>
              You may be subject to automated decision-making, including profiling, to provide services under a concluded contract
              and for direct marketing conducted by the Administrator.
            </li>
            <li>
              Personal data is not transferred to third countries within the meaning of data protection laws.
              This means we do not send them outside the European Union.
            </li>
          </ul>
    
          <h2>5. Information in Forms</h2>
          <ul>
            <li>The website collects information provided voluntarily by the user, including personal data if provided.</li>
            <li>The website may store information about connection parameters (timestamp, IP address).</li>
            <li>
              The website, in some cases, may store information facilitating the linking of data in the form with the email address
              of the user filling out the form. In such cases, the user's email address appears within the URL of the page containing the form.
            </li>
            <li>
              Data provided in the form are processed for the purpose resulting from the function of the specific form,
              e.g., for service request handling or commercial contact, service registration, etc.
              Each time the context and description of the form clearly inform what it is for.
            </li>
          </ul>
    
          <h2>6. Administrator Logs</h2>
          <ul>
            <li>Information about user behavior on the website may be subject to logging. These data are used to administer the website.</li>
          </ul>
    
          <h2>7. Important Marketing Techniques</h2>
          <ul>
            <li>
              The Operator uses statistical analysis of website traffic through Google Analytics (Google Inc. based in the USA).
              The Operator does not provide personal data to this service provider but only anonymized information.
              The service uses cookies on the user's end device.
              Regarding user preference information collected by the Google advertising network,
              the user can view and edit information derived from cookies using this tool:{' '}
              <a href="https://www.google.com/ads/preferences/">https://www.google.com/ads/preferences/</a>
            </li>
          </ul>
    
          <h2>8. Information about Cookies</h2>
          <ul>
            <li>The website uses cookies.</li>
            <li>
              Cookies are IT data, in particular text files, which are stored on the User's end device
              and intended for use on the website's pages. Cookies usually contain the name of the website they come from,
              the time they are stored on the end device, and a unique number.
            </li>
            <li>
              The entity placing cookies on the User's end device and accessing them is the website operator.
            </li>
            <li>Cookies are used for the following purposes:</li>
            <ol>
              <li>maintaining the User's session on the website (after logging in), so the User does not have to re-enter login and password on each subpage;</li>
              <li>achieving the purposes described above in the "Important Marketing Techniques" section;</li>
            </ol>
            <li>
              Two basic types of cookies are used within the website: "session" cookies and "persistent" cookies.
              "Session" cookies are temporary files that are stored on the User's end device until logging out,
              leaving the website, or closing the web browser.
              "Persistent" cookies are stored on the User's end device for the time specified in the cookie parameters
              or until they are deleted by the User.
            </li>
            <li>
              Web browsing software (web browser) usually allows cookies to be stored on the User's end device by default.
              Website users can change these settings. The web browser allows you to delete cookies.
              It is also possible to automatically block cookies. Detailed information on this is provided in the help or documentation of the web browser.
            </li>
            <li>Restrictions on the use of cookies may affect some functionalities available on the website.</li>
            <li>
              Cookies placed on the User's end device may also be used by entities cooperating with the website operator,
              in particular, this applies to companies such as Google (Google Inc., USA), Facebook (Facebook Inc., USA), Twitter (Twitter Inc., USA).
            </li>
          </ul>
    
          <h2>9. Managing Cookies – How to Express and Withdraw Consent in Practice</h2>
          <ul>
            <li>
              If the user does not want to receive cookies, they can change the browser settings.
              Please note that disabling cookies necessary for authentication, security, maintaining user preferences
              may make it difficult or, in extreme cases, impossible to use websites.
            </li>
            <li>
              To manage cookie settings, select the web browser you use from the list below and follow the instructions:
              <ul>
                <li>
                  <a href="https://support.microsoft.com/en-us/help/10607/microsoft-edge-view-delete-browser-history">Edge</a>
                </li>
                <li>
                  <a href="https://support.microsoft.com/en-us/help/278835/how-to-delete-cookie-files-in-internet-explorer">Internet Explorer</a>
                </li>
                <li>
                  <a href="http://support.google.com/chrome/bin/answer.py?hl=en&answer=95647">Chrome</a>
                </li>
                <li>
                  <a href="http://support.apple.com/kb/PH5042">Safari</a>
                </li>
                <li>
                  <a href="http://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences">Firefox</a>
                </li>
                <li>
                  <a href="http://help.opera.com/Windows/12.10/en/cookies.html">Opera</a>
                </li>
              </ul>
            </li>
            <li>Mobile devices:</li>
            <ul>
              <li>
                <a href="http://support.google.com/chrome/bin/answer.py?hl=en&answer=95647">Android</a>
              </li>
              <li>
                <a href="http://support.apple.com/kb/HT1677?viewlocale=en_US">Safari (iOS)</a>
              </li>
              <li>
                <a href="http://www.windowsphone.com/en-us/how-to/wp7/web/changing-privacy-and-other-browser-settings">
                  Windows Phone
                </a>
              </li>
            </ul>
          </ul>
        </div>
      );
}